import { CheckmarkCircleFilledIcon } from '../../../../../icons';
import { IconProps } from '../../../../../icons/templates/icon';
import { FC } from 'react';

export interface OverviewCardProps {
  label: string;
  text: string;
  icon: FC<IconProps>;
}

export const OverviewCard = ({ label, text, icon: Icon }: OverviewCardProps) => {
  return (
    <div className="relative w-full h-22 px-5 py-4 flex gap-x-4 items-center bg-grey-50 rounded-2xl">
      <div className="w-14 h-14 rounded-lg bg-primary-main text-white">
        <Icon className="w-10 h-10 p-2" />
      </div>
      <div className="flex flex-col my-1 min-w-0">
        <div className="h-6 truncate">{label}</div>
        <div className="h-6 font-medium truncate">{text}</div>
      </div>
      <div className="absolute fix top-4 right-4 text-success-main">
        <CheckmarkCircleFilledIcon className="h-5 w-5" />
      </div>
    </div>
  );
};
